/* KirbEbike home page: fixed-header offset, hero scroll hint + parallax (sections/kb-home-hero). */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;

  /* ---------- Header: keep the fixed header under the announcement bar until it scrolls away ---------- */
  const bar = document.querySelector('.shopify-section--announcement-bar');
  let ticking = false;
  const place = () => { root.style.setProperty('--kb-hn-offset', (bar ? Math.max(0, bar.offsetHeight - window.scrollY) : 0) + 'px'); ticking = false; };
  const queue = () => { if (!ticking) { ticking = true; requestAnimationFrame(place); } };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  place();

  /* ---------- Hero ---------- */
  const hh = document.querySelector('[data-kb-hh]');
  if (hh) {
    const scrollBtn = hh.querySelector('[data-kb-hh-scroll]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', () => {
        const section = hh.closest('.shopify-section');
        const next = section && section.nextElementSibling;
        const top = next ? next.getBoundingClientRect().top + window.scrollY - 76 : hh.getBoundingClientRect().bottom + window.scrollY;
        window.scrollTo({ top, behavior: reduce.matches ? 'auto' : 'smooth' });
      });
    }

    const media = hh.querySelector('.kb-hh__media');
    if (media && !reduce.matches) {
      let visible = true, raf = 0;
      const update = () => {
        raf = 0;
        const y = Math.min(window.scrollY, window.innerHeight);
        media.style.transform = `translate3d(0, ${(y * 0.14).toFixed(1)}px, 0)`;
      };
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; }).observe(hh);
      window.addEventListener('scroll', () => { if (visible && !raf) raf = requestAnimationFrame(update); }, { passive: true });
    }
  }
})();
